import React from "react";

const Textarea = ({ label, value, onChange, error, rows = 4 }) => (
  <div>
    {label && <label className="block text-sm font-medium text-foreground mb-1">{label}</label>}
    <textarea
      className={`w-full border rounded-lg p-2 text-sm text-white bg-[var(--color-background)] focus:outline-none focus:ring-2 focus:ring-primary ${error ? 'border-error' : 'border-border'}`}
      value={value}
      onChange={onChange}
      rows={rows}
    />
    {error && <p className="text-xs text-error mt-1">{error}</p>}
  </div>
);

export default Textarea;
